import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import MapView from '@arcgis/core/views/MapView';
import { MapViewInputTask } from '../framework/MapViewInputTask';
import { SurfaceBreakline } from '../model/SurfaceBreakline';
import { SurfaceDef } from '../model/SurfaceDef';
import { onBreaklineSetup, onPickPointerMove, onToolCleanup } from '../utils/ToolUtils';

export class PickBreaklineInputTask extends MapViewInputTask<SurfaceBreakline> {
  private readonly surfaceDef: SurfaceDef;

  private readonly tempBreaklinesLayer: GraphicsLayer = new GraphicsLayer({ title: 'tempBreaklinesLayer' });
  private readonly tempHighlightLayer: GraphicsLayer = new GraphicsLayer({ title: 'tempHighlightLayer' });

  private __highlightHandle: any;

  /**
   *
   * @param mapView
   * @param surfaceDef
   */
  constructor(mapView: MapView, surfaceDef: SurfaceDef) {
    super(mapView);
    this.surfaceDef = surfaceDef;
  }

  protected onSetup(): void {
    super.onSetup();
    this.cursor = 'pointer';
    onBreaklineSetup(this.cursor, this.__highlightHandle, this.tempBreaklinesLayer, this.tempHighlightLayer, this.surfaceDef.breaklines, this.mapView);
  }

  protected onCleanup(): void {
    super.onCleanup();
    onToolCleanup(this.__highlightHandle, this.tempBreaklinesLayer, this.mapView, this.tempHighlightLayer);
  }

  protected async onImmediateClick(e: __esri.ViewImmediateClickEvent): Promise<void> {
    super.onImmediateClick(e);

    const options: __esri.MapViewHitTestOptions = {};
    options.include = this.tempBreaklinesLayer;
    const result = await this.mapView.hitTest(e, options);
    if (result.results[0]) {
      const graphic = result.results[0].graphic;
      const breaklineResult: SurfaceBreakline = graphic.attributes;

      this.completeNow(breaklineResult);
    }
  }

  // protected onKeyDown(e: __esri.ViewKeyDownEvent): void {
  //   super.onKeyDown(e);
  // }

  protected async onPointerMove(e: __esri.ViewPointerMoveEvent): Promise<void> {
    await onPickPointerMove(e, this.tempHighlightLayer, this.tempBreaklinesLayer, this.mapView, this.__highlightHandle);
  }
}
